import { environment } from 'src/environments/environment';

export function AttachImageUrl(data: any[], fieldList: string[], type = 'h') {
  fieldList.forEach(field => {
    for (const item of data) {
      if (item[field]) {
        item[field] = environment.imageUrl + (item[field]);
      } else {
        switch (type) {
          case 'v':
            item[field] = '/assets/img-defult-v.jpeg';
            break;
          case 'h':
            item[field] = '/assets/img-defult-h.jpeg';
            break;
          case 'u':
            item[field] = '/assets/circle-08.svg';
            break;
          case 'n':
            item[field] = null;
            break;
        }
      }
    }
  });

}
